import { 
  SET_TOURNAMENT_MANAGER_EDITING,
  SET_TOURNAMENT_MANAGERS_IN_STATE,
  SET_TOURNAMENT_ADMINISTRATOR_EDITING,
  SET_TOURNAMENT_ADMINISTRATORS_IN_STATE
} from "./constants";

export const toggleTournamentManagerEditing = id => ({
  type: SET_TOURNAMENT_MANAGER_EDITING,
  payload: id
});

export const setTournamentManagers = managers => ({
  type: SET_TOURNAMENT_MANAGERS_IN_STATE,
  payload: managers
});

export const toggleTournamentAdministratorEditing = id => ({
  type: SET_TOURNAMENT_ADMINISTRATOR_EDITING,
  payload: id
});

export const setTournamentAdministrators = administrators => ({
  type: SET_TOURNAMENT_ADMINISTRATORS_IN_STATE,
  payload: administrators
});



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/actionTypes.js